<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
  214 West 29th St.<br/>
  New York NY 10001<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
<br/>
  Copyright © Flammarion, Paris, 1994<br/>
  First published by Arthaud, 1989<br/>
  First publication 2019 by Europa Editions<br/>
<br/>
  Translation by Siân Reynolds<br/>
  Original Title: <i>Le Modèle italien<br/></i>Translation copyright © 1991 by Flammarion<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
<br/>
  Cover image: Album / Alamy Stock Photo<br/>
<br/>
  ISBN 9781609455354 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?a0907c2e